import { atomWithReset } from "jotai/utils"

export const productFilterFormDataAtom = atomWithReset<Record<string, string | number>>({})
